var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadioButtonActive = function SvgRadioButtonActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 6,
    y: 6,
    stroke: "#3AACC8",
    strokeWidth: 1.5,
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 9,
    y: 9,
    fill: "#3AACC8",
    stroke: "#3AACC8",
    strokeWidth: 1.5,
    rx: 3
  })));
};
export { SvgRadioButtonActive as ReactComponent };
export default __webpack_public_path__ + "6f83656df02e5132bbaf3cadaa988a70.svg";